/*export function ajaxError(err,status){
  if(err.response && err.response.status==401){
    location.href='/'
  }else{
    throw err;
  }
}*/

import {MessageBox} from 'element-ui';
import {Message} from 'element-ui';
// import store from '@/common/vuex/store';
let showMessage=false;
export function ajaxError(err,status,url){
  if(!(window.location.href.indexOf('/login')>-1)){
    if(url && (url.indexOf('loginUserInfo')>-1 || url.indexOf('logout')>-1)){
      return;
    }
    if(err.response && err.response.status==401  || (err.response && err.response.data.indexOf('/login')>-1) || '401'==status){
      if(window.$Env && $Env.sessionTimeoutToLogin){
        window.location.href = "/logout";
      }else if(!showMessage ){
        showMessage=true;
        MessageBox.prompt('登录超时,请输入密码', {
          confirmButtonText: '确定',
          showClose:false,
          showCancelButton:false,
          inputType:'password',
          beforeClose:function(action, instance, done){
            if(action=='confirm'){
              let value=instance.inputValue;
              if(PF.userInfo.developer){
                this.mwApi.org.authenticateDev(PF.userInfo.loginId,value,true).then(res => {
                  if (res.success && res.result) {
                    showMessage=false;
                    done();
                  }else{
                    PF.message("error",'密码验证错误，请重新输入！');
                  }
                });
              }else{
                this.mwApi.org.authenticate(PF.userInfo.loginId,value,true).then(res => {
                  if (res.success && res.result) {
                    showMessage=false;
                    done();
                  }else{
                    PF.message("error",'密码验证错误，请重新输入！');
                  }
                });
              }
            }
          }
        }).then(({ value }) => {

        }).catch(() => {

        });
      }
    }else if(err.response && err.response.status==600  || (err.response && err.response.data.indexOf('/login')>-1) || '600'==status){
      if(!showMessage ){
        showMessage=true;
        MessageBox.prompt('此账号已在其他设备登录,请输入密码', {
          confirmButtonText: '确定',
          showClose:false,
          showCancelButton:false,
          inputType:'password',
          beforeClose:function(action, instance, done){
            if(action=='confirm'){
              let value=instance.inputValue;
              if(PF.userInfo.developer){
                this.mwApi.org.authenticateDev(PF.userInfo.loginId,value,true).then(res => {
                  if (res.success && res.result) {
                    showMessage=false;
                    done();
                  }else{
                    PF.message("error",'密码验证错误，请重新输入！');
                  }
                });
              }else{
                this.mwApi.org.authenticate(PF.userInfo.loginId,value,true).then(res => {
                  if (res.success && res.result) {
                    showMessage=false;
                    done();
                  }else{
                    PF.message("error",'密码验证错误，请重新输入！');
                  }
                });
              }
            }
          }
        }).then(({ value }) => {

        }).catch(() => {

        });
      }
    }else{
      throw err;
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/utils/ajaxError.js